import { IAuthService } from "./AuthService";

/** Complete the designer's user-initiated sign-in request outside its sandboxed iframe. */
export async function handleRuntimeReauthenticationRequest(authService: IAuthService): Promise<void> {
  if (window.self !== window.top) return;

  const currentUrl = new URL(window.location.href);
  if (currentUrl.searchParams.get("reauth") !== "1") return;

  currentUrl.searchParams.delete("reauth");
  window.history.replaceState(window.history.state, "", currentUrl.toString());
  await authService.signIn("/");
}
